export default __webpack_public_path__ + "static/media/PEACH.64b319f1.svg";